import { render } from "./NewsDetailView.vue?vue&type=template&id=b186651c&scoped=true"
import script from "./NewsDetailView.vue?vue&type=script&lang=js"
export * from "./NewsDetailView.vue?vue&type=script&lang=js"

import "./NewsDetailView.vue?vue&type=style&index=0&id=b186651c&scoped=true&lang=css"

import exportComponent from "/usr/src/app/ziohome_ver3_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b186651c"]])

export default __exports__